import { PendingOrdersContext } from 'pages/pending_orders/context';
import { DefaultLayout } from 'components/layout';
import { Outlet } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { useApp } from 'app';

export type PendingOrderPermissions = {
    CanCancel: boolean;
    CanFillInventory: boolean;
    CanFillNewOrder: boolean;
};

export type PendingOrdersContextValue = {
    permissions: PendingOrderPermissions;
};

export const PendingOrders = () => {

    const { highestRole } = useApp();
    const { formatMessage } = useIntl();
    const resolvedRoleId = highestRole.id ?? 0;

    const resolvedPermissions: PendingOrderPermissions = {
        CanCancel: true,
        CanFillInventory: true,
        CanFillNewOrder: resolvedRoleId !== 1
    };

    const context: PendingOrdersContextValue = {
        permissions: resolvedPermissions
    };

    return (
        <DefaultLayout pageTitle={formatMessage({ id: 'pending_orders.abd66f4e', defaultMessage: 'Pending Orders' })}>
            <PendingOrdersContext.Provider value={context}>
                <Outlet />
            </PendingOrdersContext.Provider>
        </DefaultLayout>
    );

};
